import { lazy, Suspense } from 'react';

const ReactLottie = lazy(() => import('react-lottie'));

const defaultOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const Lottie = (props) => {
  const { width = 200, height = 200, speed = 0.5, options } = props;

  return (
    <Suspense fallback={null}>
      <ReactLottie
        style={{ margin: 0 }}
        speed={speed}
        options={{ ...defaultOptions, ...options }}
        height={height}
        width={width}
      />
    </Suspense>
  );
};
